import React, { useRef, useState } from "react";
import Sidebar from "../../components/sidebar";
import { toast } from "react-toastify";
import { useEffect } from "react";
import moment from "moment";
import useSignOut from "../../utils/sign-out";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Header from "../../components/header";
import Footer from "../../components/footer";
import MenuIcon from "../../assets/settings/menu-icon.svg";
import Lock from "../../assets/settings/lock.svg";
import FunnelStepTypes from "../funnel-step/types";
import { useTranslation } from "react-i18next";

import {
  formatToTwoDecimalPlaces,
  getActionButtons,
  getCookie,
  getCountryCode,
  getGuestUserStatus,
  getInvitationStatusColor,
  InvitationStatus,
} from "../../utils/utility-functions";
import {
  allowOnlyAlphabetsAndNumbersAndSpaces,
  allowOnlyNumbers,
  validatePassword,
} from "../../utils/validation";
import Loader from "../../components/loader";
import Table from "../../components/table";
import { CreateNewUserModel } from "../../components/model/component";
import { getPortalCD, readCookie, createCookie } from "../../utils/helpers";
import { capitalizeFirstLetter } from "../../utils/general-config";

import { useDispatch } from "react-redux";
import CancelPlanPopup from "../../components/cancel-plan-popup/component";
import {
  APP_NAVIGATION,
  LOCALE,
  PLAN_DEFAULT_SKU_SUB_CATEGORY,
} from "../../utils/constants";
import PathHelper from "../../utils/path-helper";

const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

function Settings({
  ChangePasswordConnect,
  GetUserByIdConnect,
  funnelStep,
  AccountCancellationConnect,
  GetTransactionDetailConnect,
  GetBillingConnect,
  UpdateUserConnect,
  GetGuestUserConnect,
  GuestUserChangesConnect,
  UpdateGuestUserConnect,
  IsGuestOrPremiumUserConnect,
  AccountReActivateConnect,
  getPlansConnect,
}) {
  const [openMenuSetting, setOpenMenuSettings] = useState(false);
  const {
    userGUID: userGuid,
    selectedPlan,
    isGuestUser,
    currencyCD,
    countryCD: reduxCountryCD,
    region: reduxRegion,
    isAuth,
  } = funnelStep;

  const countryCD = getCountryCode(reduxCountryCD);
  const [isOpenCancellation, setIsOpenCancellation] = useState(false);
  const [isBillingLoading, setIsBillingLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [guestUserData, setGuestUserData] = useState([]);

  const [isLoadingGuesUserChanges, setLoadingGuestUserChange] = useState({
    removed: false,
    resent: false,
    cancel: false,
  });
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const [planData, setPlanData] = useState([]);
  const [guestUserCount, setGuestUserCount] = useState(0);
  const [openCreateUser, setOpenCreateUser] = useState(false);
  // const token = getCookie("jwtToken");
  // const token = localStorage.getItem("jwtToken");
  const [transactionDetails, setTransactionDetail] = useState(null);
  const [billingDetails, setBillingDetails] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [skuId, setSkuId] = useState("");
  const [selectedGenderValue, setSelectedGenderValue] = useState();
  const [originalProfileData, setOriginalProfileData] = useState({});
  const [profileData, setProfileData] = useState({
    phoneNumber: "",
    company: "",
    bio: "",
    name: "",
    gender: "",
  });
  const dropdownRef = useRef(null);

  const [searchParams] = useSearchParams();
  const steps = searchParams.get("steps");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const signOut = useSignOut();
  const [isPremiumOrGuest, setIsPremiumOrGuest] = React.useState(false);
  const [changePassword, setChangePassword] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [changePasswordError, setChangePasswordError] = useState({
    currentPasswordErr: "",
    newPasswordErr: "",
    confirmPasswordErr: "",
  });
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const [changePasswordCheck, setChangePasswordCheck] = useState(false);
  const nameParts = profileData.name.split(" ");
  const FIRST_NAME = nameParts[0];
  const lastNamePart1 = nameParts[1] || ""; // Get the second part, or an empty string if undefined
  const lastNamePart2 = nameParts[2] || "";
  const LAST_NAME = lastNamePart1 + " " + lastNamePart2;
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);
  const planPath = PathHelper(APP_NAVIGATION.PLAN, currentLocale);

  const region = reduxRegion;
  const country = countryCD;
  const location = `${region}, ${country}`;

  const isNormalUser =
    (userData && userData?.socialLogin === null) || !userData?.socialLogin;

  useEffect(() => {
    if (userGuid) {
      setIsLoading(true);
      GetUserByIdConnect(userGuid).then((res) => {
        if (res) {
          setUserData(res);
          const fullName = `${res.firstName || ""} ${
            res.lastName || ""
          }`.trim();
          const profileDefaults = {
            name: fullName,
            bio: res.bio || "",
            phoneNumber: res.phoneNumber || "",
            company: res.company || "",
          };
          setProfileData(profileDefaults);
          setOriginalProfileData(profileDefaults);
          setIsLoading(false);
        }
      });
      if (!isGuestUser) {
        GetTransactionDetailConnect(userGuid).then((res) => {
          if (res && Object.keys(res).length > 0) {
            setTransactionDetail(res);
            const gatewayRequest = res.gatewayRequest;
            try {
              const jsonReq = JSON.parse(gatewayRequest);
              setSkuId(jsonReq?.SKUGuid ?? null);
            } catch (error) {
              setSkuId(null); // optional fallback
            }
          } else {
            setTransactionDetail(null);
            setSkuId(null);
            getPlansConnect({
              planType: "_default",
              currencyCD,
              countryCD,
              device: "null",
              locale:
                currentLocale === LOCALE.EN || currentLocale === LOCALE.ES
                  ? currentLocale
                  : LOCALE.EN,
            }).then((result) => {
              const defaultPlan = result?.filter((item) => {
                return (
                  item?.skuSubCategory.toLowerCase() ===
                  PLAN_DEFAULT_SKU_SUB_CATEGORY.toLowerCase()
                );
              });
              setPlanData(defaultPlan);
              setIsLoading(false);
            });
          }
        });

        GetGuestUserConnect(userGuid).then((res) => {
          if (res) {
            const filteredData = res.filter(
              (item) =>
                item.invitationStatus === InvitationStatus.Sent ||
                item.invitationStatus === InvitationStatus.Accepted,
            );
            setGuestUserData(res);
            setGuestUserCount(filteredData.length);
            //createCookie("guestUserCount", filteredData.length, 1);
          }
        });
      }
    }
  }, [userGuid]);

  useEffect(() => {
    if (userGuid) {
      IsGuestOrPremiumUserConnect(userGuid).then((res) => {
        if (res) {
          setIsPremiumOrGuest(res?.isPremiumOrGuestUser);
        }
      });
    }
  }, [userGuid]);
  const fetchBillingDetails = () => {
    if (transactionDetails && transactionDetails?.id) {
      let skuGuid = selectedPlan?.id;
      if (!skuGuid) {
        skuGuid = skuId;
      }
      const data = {
        skuGuid: skuGuid,
        transId: transactionDetails?.id,
        locale: currentLocale,
      };

      setIsBillingLoading(true); // Set loading to true before fetching
      GetBillingConnect(data)
        .then((res) => {
          setBillingDetails(res);
          if (res.maxSubUserCount !== undefined) {
            dispatch(
              PushUserInformationToFunnelStep({
                maxSubUserCount: res.maxSubUserCount,
              }),
            );
            // createCookie("maxSubUserCount", res.maxSubUserCount, 1);
          }
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          setIsBillingLoading(false); // Set loading to false after fetching
        });
    }
  };
  useEffect(() => {
    fetchBillingDetails();
  }, [transactionDetails]);

  // useEffect(() => {
  //   if (transactionDetails && transactionDetails?.id) {
  //     let skuGuid = selectedPlan?.id;
  //     if (!skuGuid) {
  //       skuGuid = skuId;
  //     }
  //     const data = {
  //       skuGuid: skuGuid,
  //       transId: transactionDetails?.id,
  //       locale: "en",
  //     };
  //     GetBillingConnect(data).then((res) => {
  //       setBillingDetails(res);
  //     });
  //   }
  // }, [transactionDetails]);

  useEffect(() => {
    if (!isAuth) {
      navigate(loginPath.next);
    }
  }, [isAuth]);

  const handleChangeProfile = (event) => {
    const { name, value } = event.target;
    setProfileData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setOriginalProfileData();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // const data = {
    //   // ...rest,
    //   userGuid,
    //   bio: profileData?.bio || "",
    //   company: profileData?.company || "",
    //   phoneNumber: profileData?.phoneNumber || "",
    //   // name: profileData?.name || userData?.name || "",
    //   firstName: FIRST_NAME || "",
    //   lastName: LAST_NAME?.trim() ? LAST_NAME : userData?.lastName,
    //   gender: profileData?.gender || "",
    // };
    const data = {
      userGuid,
    };

    // bio
    if (profileData?.bio !== userData?.bio) {
      data.bio = profileData.bio || "";
    }

    // company
    if (profileData?.company !== userData?.company) {
      data.company = profileData.company || "";
    }

    // phoneNumber
    if (profileData?.phoneNumber !== userData?.phoneNumber) {
      data.phoneNumber = profileData.phoneNumber || "";
    }

    // full name split to first and last name
    const newName = profileData?.name?.trim();
    if (
      newName &&
      newName !==
        `${userData?.firstName || ""} ${userData?.lastName || ""}`.trim()
    ) {
      const [firstName, ...rest] = newName.split(" ");
      data.firstName = firstName;
      data.lastName = rest.join(" ");
    }

    if (profileData?.gender && profileData.gender !== userData?.gender) {
      data.gender = profileData.gender;
    }

    UpdateUserConnect(data).then((res) => {
      if (res) {
        toast.success(t("settings.profile_update_success_msg"));
        GetUserByIdConnect(userGuid).then((res) => {
          if (res) {
            setUserData(res);
          }
        });
      }
    });
  };

  const handleChangePassword = (e) => {
    const { name, value } = e.target;
    setChangePassword((prevFormData) => ({ ...prevFormData, [name]: value }));

    // Clear error message when user starts typing
    if (name === "currentPassword" && changePasswordError.currentPasswordErr) {
      setChangePasswordError((prevError) => ({
        ...prevError,
        currentPasswordErr: "",
      }));
    } else if (name === "newPassword" && changePasswordError.newPasswordErr) {
      setChangePasswordError((prevError) => ({
        ...prevError,
        newPasswordErr: "",
      }));
    } else if (
      name === "confirmPassword" &&
      changePasswordError.confirmPasswordErr
    ) {
      setChangePasswordError((prevError) => ({
        ...prevError,
        confirmPasswordErr: "",
      }));
    }
    setChangePassword((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  const handleSubmitChangePassword = (event) => {
    event.preventDefault();

    let currentPasswordErr = "";
    let newPasswordErr = "";
    let confirmPasswordErr = "";

    // Validate current password
    currentPasswordErr = validatePassword(
      changePassword.currentPassword.trim(),
    );

    // Validate new password
    newPasswordErr = validatePassword(changePassword.newPassword.trim());

    // Confirm password validation
    if (!changePassword.confirmPassword) {
      confirmPasswordErr = t("settings.confirm_password_req_msg");
    } else if (changePassword.confirmPassword !== changePassword.newPassword) {
      confirmPasswordErr = t("settings.confirm_password_err_msg");
    }

    // Check if there are any errors
    if (currentPasswordErr || newPasswordErr || confirmPasswordErr) {
      setChangePasswordError({
        currentPasswordErr,
        newPasswordErr,
        confirmPasswordErr,
      });
      return;
    }

    const { currentPassword, newPassword } = changePassword;
    const data = {
      currentPassword,
      newPassword,
      userGuid,
    };

    ChangePasswordConnect(data).then((res) => {
      if (res && res?.passwordReset) {
        toast.success(t("settings.password_changed_success_msg"));
        signOut({ isNavigate: true });
      } else {
        toast.error(t("settings.invalid_current_err_msg"));
      }
    });
  };

  const handleAccountCancellation = () => {
    const data = {
      isEndOfTerm: true,
      comment: "USER:CancelAccount",
      userGuid: userGuid,
      locale: currentLocale,
    };
    setIsLoading(true);
    AccountCancellationConnect(data)
      .then((res) => {
        if (res.data) {
          setIsOpenCancellation(false);
          toast.success(t("settings.account_cancle_success_msg"));
          fetchBillingDetails();
          // signOut();
        }
      })
      .catch((err) => {
        console.log({ err });
        setIsLoading(false);
        toast.error("settings.account_cancle_fail_msg");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const NEXT_BILLING_DATE = moment(billingDetails?.nextBillingDate).format(
    "MMMM DD, YYYY",
  );

  const PLAN_DESCRIPTION = billingDetails?.planDescription;
  const PLAN_KEY = billingDetails?.planKey;
  const RECURRING_PRICE = billingDetails?.recurringPrice;
  const CANCELLED_USER =
    billingDetails?.statusInChargebee?.toLowerCase() === "cancelled";
  const CURRENCY_SYMBOL = billingDetails?.currencySymbol || "";

  // Replace XXXX in PLAN_DESCRIPTION with the value of RECURRING_PRICE
  const updatedPlanDescription = PLAN_DESCRIPTION?.replaceAll(
    "XXXX",
    `${CURRENCY_SYMBOL}${formatToTwoDecimalPlaces(RECURRING_PRICE)}`,
  );

  const defaultPlanDescription =
    planData.length > 0 && planData[0]?.description.replace("YYYY.", "");

  const defaultPlanKey = planData.length > 0 && planData[0]?.label;

  const cancelledAt = moment(billingDetails?.cancelledAt).format(
    "MMMM DD, YYYY",
  );
  const isScheduleCancel = billingDetails?.isScheduleCancel;
  const cancelDescription = `${t(
    "checkout.cancel_description",
  )} ${cancelledAt}.`;

  const firstName = userData?.firstName || ""; // Ensure firstName is not undefined
  const lastName = userData?.lastName || ""; // Ensure lastName is not undefined
  const fullName = firstName + (lastName ? ` ${lastName}` : "");
  const gender = userData?.gender ?? "female";

  const isUpdateProfile =
    profileData?.name !== originalProfileData?.name ||
    profileData?.gender !== originalProfileData?.gender ||
    profileData?.bio !== originalProfileData?.bio ||
    profileData?.phoneNumber !== originalProfileData?.phoneNumber ||
    profileData?.company !== originalProfileData?.company;
  const togglePasswordVisibility = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const onResend = (item) => {
    if (guestUserCount < billingDetails?.maxSubUserCount) {
      const resendInvitationData = {
        guestUser: {
          id: item?.id,
          firstName: item?.firstName,
          lastName: item?.lastName,
          emailAddress: item?.emailAddress,
          invitationStatus: InvitationStatus.Sent,
        },
        userGuid: item?.parentId,
        locale: currentLocale,
        portalCD: getPortalCD(currentLocale),
      };
      setLoadingGuestUserChange({
        ...isLoadingGuesUserChanges,
        resent: true,
      });
      GuestUserChangesConnect(resendInvitationData).then((res) => {
        GetGuestUserConnect(item?.parentId)
          .then((res) => {
            if (res) {
              setGuestUserData(res);
              const filteredData = res.filter(
                (item) =>
                  item.invitationStatus === InvitationStatus.Sent ||
                  item.invitationStatus === InvitationStatus.Accepted,
              );
              setGuestUserCount(filteredData.length);
              //createCookie("guestUserCount", filteredData.length, 1);
            }
          })
          .finally(() => {
            setLoadingGuestUserChange({
              ...isLoadingGuesUserChanges,
              resent: false,
            });
          });
      });
    } else {
      toast.warning(t("settings.max_user_reached_msg"));
    }
  };

  const onCancel = (item) => {
    const resendInvitationData = {
      guestUser: {
        id: item.id,
        firstName: item?.firstName,
        lastName: item?.lastName,
        emailAddress: item?.emailAddress,
        invitationStatus: InvitationStatus.InvitationCancelled,
      },
      userGuid: item?.parentId,
      locale: currentLocale,
      portalCD: getPortalCD(currentLocale),
    };
    setLoadingGuestUserChange({
      ...isLoadingGuesUserChanges,
      cancel: true,
    });
    GuestUserChangesConnect(resendInvitationData).then((res) => {
      GetGuestUserConnect(item?.parentId)
        .then((res) => {
          if (res) {
            setGuestUserData(res);
            const filteredData = res.filter(
              (item) =>
                item.invitationStatus === InvitationStatus.Sent ||
                item.invitationStatus === InvitationStatus.Accepted,
            );
            setGuestUserCount(filteredData.length);
          }
        })
        .finally(() => {
          setLoadingGuestUserChange({
            ...isLoadingGuesUserChanges,
            cancel: false,
          });
        });
    });
  };
  const handleToggle = () => setIsOpen(!isOpen);

  const onRemove = (item) => {
    const resendInvitationData = {
      guestUser: {
        id: item.id,
        firstName: item?.firstName,
        lastName: item?.lastName,
        emailAddress: item?.emailAddress,
        invitationStatus: InvitationStatus.Removed,
      },
      userGuid: item?.parentId,
      locale: currentLocale,
      portalCD: getPortalCD(currentLocale),
    };
    setLoadingGuestUserChange({
      ...isLoadingGuesUserChanges,
      removed: true,
    });
    GuestUserChangesConnect(resendInvitationData).then((res) => {
      GetGuestUserConnect(item?.parentId)
        .then((res) => {
          if (res) {
            setGuestUserData(res);
            const filteredData = res.filter(
              (item) =>
                item.invitationStatus === InvitationStatus.Sent ||
                item.invitationStatus === InvitationStatus.Accepted,
            );
            setGuestUserCount(filteredData.length);
          }
        })
        .finally(() => {
          setLoadingGuestUserChange({
            ...isLoadingGuesUserChanges,
            removed: false,
          });
        });
    });
  };
  const mapGuestUserData = guestUserData?.map((item) => {
    const statusText = getGuestUserStatus(item?.invitationStatus, t);
    const statusColor = getInvitationStatusColor(statusText, t);
    // Call the reusable function
    return {
      email: item?.emailAddress,
      status: (
        <span
          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${statusColor}`}
        >
          {statusText}
        </span>
      ),
      actions: (
        <div className="flex items-center gap-3 cursor-pointer">
          {getActionButtons(
            statusText,
            item,
            onResend,
            onCancel,
            onRemove,
            t,
          )}{" "}
        </div>
      ),
    };
  });
  useEffect(() => {
    if (userData?.gender) {
      setSelectedGenderValue(capitalizeFirstLetter(userData.gender));
      dispatch(
        PushUserInformationToFunnelStep({
          userGUID: userGuid,
          email: userData.email,
          gender: userData.gender,
        }),
      );
    }
  }, [userData?.gender]);

  const GENDER_OPTIONS = [
    { label: t("quiz.male"), value: "male" },
    { label: t("quiz.female"), value: "female" },
    { label: t("quiz.other"), value: "other" },
  ];
  const handleSelect = (option) => {
    setSelectedGenderValue(option.label); // Update input with the selected value
    handleChangeProfile({ target: { name: "gender", value: option.value } });
    setIsOpen(false); // Close the dropdown
  };

  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState();

  useEffect(() => {
    const controlNavbar = () => {
      if (typeof window !== "undefined") {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
          // Scrolling down
          setIsButtonVisible(false);
          setOpenMenuSettings(false);
        } else if (currentScrollY < lastScrollY) {
          // Scrolling up more than 10 pixels
          setIsButtonVisible(true);
        }

        setLastScrollY(currentScrollY);
      }
    };

    window.addEventListener("scroll", controlNavbar);

    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);

  useEffect(() => {
    const userManagementSection = document.getElementById(steps);

    if (userManagementSection && !isLoading) {
      // Calculate the offset position
      const offsetPosition =
        userManagementSection.getBoundingClientRect().top +
        window.scrollY -
        100; // Adjust the offset as needed

      // Scroll to the calculated position with an offset
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth", // Use "smooth" for a smooth scroll
      });
    } else {
      console.warn(`Element with ID "${steps}" not found.`);
    }
  }, [steps, isLoading]);

  if (isLoading) {
    return <Loader isLoading={isLoading} />;
  }

  const getGenderLabel = (gender, t) => {
    if (!gender || typeof gender !== "string") return null;

    const upperGender = gender.toUpperCase();

    switch (upperGender) {
      case "MALE":
        return currentLocale === "es" ? t("quiz.male") : "Male";
      case "FEMALE":
        return currentLocale === "es" ? t("quiz.female") : "Female";
      case "OTHER":
        return currentLocale === "es" ? t("quiz.other") : "Other";
      default:
        return gender;
    }
  };

  const handleReactivate = () => {
    const data = {
      transactionId: transactionDetails?.id,
      isCancelled:
        billingDetails?.statusInChargebee.toLowerCase() === "cancelled"
          ? true
          : false,
    };
    setIsLoading(true);
    AccountReActivateConnect(data)
      .then((response) => {
        if (response) {
          fetchBillingDetails();
          toast.success(t("settings.account_reactivate_msg"));
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t("settings.reactivate_fail_msg"));
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Header />
      <div
        className="lg:flex mx-auto px-4 py-0 justify-center "
        id="settings-page-container"
      >
        <div
          id="settings-mobile-menu-container"
          className={`lg:hidden fixed bottom-0 max-w-full w-full right-0 left-0 px-[10px] mb-4 mt-4  z-10 duration-300 flex flex-col 
          ${isButtonVisible ? "opacity-100" : "opacity-100 bottom-[-200px]"}`}
        >
          {openMenuSetting && (
            <aside
              className="mb-8 md:mb-16 bottom-0 fixed max-w-full w-full px-[10px] place-self-center"
              id="settings-mobile-sidebar-container"
            >
              <Sidebar
                open={openMenuSetting}
                setOpen={setOpenMenuSettings}
                isNormalUser={isNormalUser}
                isHide={!!isScheduleCancel && isScheduleCancel === true}
                isGuestUser={isGuestUser}
                isPremiumOrGuest={isPremiumOrGuest}
              />
            </aside>
          )}
          <button
            id="settings-mobile-menu-button"
            className="w-full z-10 flex items-center justify-between px-4 py-2 mb-0 bg-white rounded-lg shadow-2xl shadow-insightful-gray text-gray-800 focus:outline-none focus:ring-2 focus:ring-insightful-purple"
            onClick={(e) => {
              //document.body.style.overscroll = openMenuSetting ? 'auto' : 'contain';
              setOpenMenuSettings(!openMenuSetting);
            }}
          >
            <span className="font-semibold z-10" id="settings-mobile-menu-text">
              {t("settings.settings_menu")}
            </span>
            <img
              src={MenuIcon}
              alt="mobile settings icon"
              className="z-10"
              id="settings-mobile-menu-icon"
            />
          </button>
        </div>
        <Loader
          isLoading={
            isLoadingGuesUserChanges.resent ||
            isLoadingGuesUserChanges.cancel ||
            isLoadingGuesUserChanges.removed
          }
        />
        <div
          className=" w-full mx-auto my-1 flex items-start justify-center md:px-[10px] lg:p-[10px] max-w-[1260px]"
          id="settings-main-content"
        >
          <aside
            className="hidden lg:block sticky mt-1 mr-2 h-80 lg:top-[100px] "
            id="settings-desktop-sidebar"
          >
            <Sidebar
              open={true}
              setOpen={setOpenMenuSettings}
              isNormalUser={isNormalUser}
              isHide={!!isScheduleCancel && isScheduleCancel === true}
              isGuestUser={isGuestUser}
              isPremiumOrGuest={isPremiumOrGuest}
            />
          </aside>

          <div
            className="w-full max-w-full overflow-x-hidden"
            id="settings-content-container"
          >
            <div className="flex-col" id="settings-sections-wrapper">
              {/* {--------------------PROFILE SECTION --------------------------------} */}
              <section
                className="bg-white rounded-lg shadow-lg py-8 px-[10px] lg:px-[30px] mb-8"
                id="profile"
              >
                <h2
                  className="text-[24px] lg:text-[30px] font-bold mb-2 lg:mb-6 text-gray-800"
                  id="profile-section-title"
                >
                  {t("settings.profile_settings")}
                </h2>
                <form onSubmit={handleSubmit} id="profile-form">
                  <div
                    className="max-w-full mb-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg p-2 lg:p-6 text-white flex items-center"
                    id="profile-header-banner"
                  >
                    <div
                      className="flex items-center lg:space-x-6"
                      id="profile-banner-content"
                    >
                      <div
                        className="h-10 w-10 p-8 flex items-center justify-center rounded-full border-4 border-white shadow-lg  text-white font-semibold text-[24px] lg:text-[30px]"
                        id="profile-avatar-circle"
                      >
                        {userData &&
                          (!!userData?.firstName
                            ? userData?.firstName.charAt(0).toUpperCase()
                            : userData?.email.charAt(0).toUpperCase()) +
                            (!!userData?.lastName
                              ? userData?.lastName.charAt(0).toUpperCase()
                              : "")}
                      </div>

                      <div
                        className="w-[220px] md:w-full flex-col items-center overflow-clip max-w-full"
                        id="profile-user-info"
                      >
                        <h3
                          className="ml-[10px] text-2xl font-bold"
                          id="profile-full-name-display"
                        >
                          {fullName}
                        </h3>
                        <p
                          className="max-w-max ml-[10px] text-[16px] md:text-[20px] opacity-80 overflow-ellipsis"
                          id="profile-bio-display"
                        >
                          {userData?.bio && userData?.bio}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">
                    <div className="space-y-4">
                      <div>
                        <label
                          htmlFor="name"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          {t("settings.full_name_label")}
                        </label>
                        <input
                          type="text"
                          id="settings-page-name"
                          name="name"
                          defaultValue={fullName}
                          className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                          onChange={handleChangeProfile}
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          {t("settings.email_label")}
                        </label>
                        <input
                          type="email"
                          id="settings-page-email"
                          name="email"
                          value={userData?.email}
                          className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                          readOnly
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="phoneNumber"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          {t("settings.phone_number_label")}
                        </label>
                        <input
                          type="tel"
                          id="settings-page-phone-number"
                          name="phoneNumber"
                          defaultValue={
                            userData?.phoneNumber || profileData.phoneNumber
                          }
                          className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                          onChange={handleChangeProfile}
                          onInput={(e) => {
                            allowOnlyNumbers(e);
                          }}
                          maxLength={10}
                        />
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div
                        className="block text-sm font-medium text-gray-700 mb-1"
                        ref={dropdownRef}
                      >
                        <label
                          htmlFor="gender"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          {t("settings.gender_label")}
                        </label>
                        <input
                          id="gender"
                          name="settings-page-gender"
                          value={getGenderLabel(selectedGenderValue, t)} // Show selected value
                          className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                          onClick={handleToggle} // Toggle the dropdown on click
                          readOnly // Input should be read-only so it behaves like a dropdown
                        />
                        {isOpen && (
                          <div className="absolute flex flex-grow mt-1 rounded-lg bg-white shadow-lg shadow-insightful-light-gray w-[323px] max-w-[362px] md:w-[421px] lg:max-w-[421.2px]">
                            <ul className="h-auto w-full max-w-full rounded-lg sticky py-1 text-base ring-1 ring-black ring-opacity-5 overflow-none focus:outline-none sm:text-sm">
                              {GENDER_OPTIONS.map((option) => (
                                <li
                                  id={option.value}
                                  key={option.value}
                                  className="text-gray-900 cursor-default select-none py-[10px] px-[20px] hover:bg-insightful-lightest-gray hover:text-black"
                                  onClick={() => handleSelect(option)} // Handle the selection
                                >
                                  {option.label}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                      {/* <div>
                      <label
                        htmlFor="username"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Username
                      </label>
                      <input
                        type="text"
                        name="userName"
                        value={userData?.userName}
                        className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                        onChange={handleChangeProfile}
                        readOnly
                      />
                    </div> */}
                      <div id="profile-location-field-wrapper">
                        <label
                          htmlFor="location"
                          className="block text-sm font-medium text-gray-700 mb-1"
                          id="profile-location-label"
                        >
                          {t("settings.location_label")}
                        </label>
                        <input
                          type="text"
                          id="settings-page-location"
                          name="location"
                          value={location}
                          className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                          onChange={handleChangeProfile}
                          readOnly
                        />
                      </div>
                      <div id="profile-company-field-wrapper">
                        <label
                          htmlFor="company"
                          className="block text-sm font-medium text-gray-700 mb-1"
                          id="profile-company-label"
                        >
                          {t("settings.company_label")}
                        </label>
                        <input
                          type="text"
                          id="settings-page-company"
                          name="company"
                          defaultValue={
                            userData?.company || profileData.company
                          }
                          className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                          onChange={handleChangeProfile}
                        />
                      </div>
                    </div>
                    <div
                      className="md:col-span-2"
                      id="profile-bio-field-wrapper"
                    >
                      <label
                        htmlFor="bio"
                        className="block text-sm font-medium text-gray-700 mb-1"
                        id="profile-bio-label"
                      >
                        {t("settings.bio_label")}
                      </label>
                      <textarea
                        id="settings-page-bio"
                        name="bio"
                        rows="4"
                        defaultValue={userData?.bio || profileData.bio}
                        className="mt-1 block w-full bg-[#f8f8f8] rounded-lg border-insightful-gray border-1 p-2 shadow-sm focus:border-insightful-purple focus:ring focus:ring-insightful-purple focus:ring-opacity-50"
                        onChange={handleChangeProfile}
                        onInput={(e) => {
                          allowOnlyAlphabetsAndNumbersAndSpaces(e);
                        }}
                        maxLength={200}
                      />
                    </div>
                  </div>
                  <div
                    className="mt-8 flex justify-center lg:justify-end"
                    id="profile-submit-container"
                  >
                    <button
                      id="settings-page-profile-save-button"
                      type="submit"
                      className={`px-6 py-3 bg-insightful-purple text-white rounded-md hover:bg-insightful-purple focus:outline-none focus:ring-2 focus:ring-insightful-purple focus:ring-offset-2 transition duration-300 ease-in-out transform ${
                        !isUpdateProfile ? "cursor-not-allowed" : ""
                      }`}
                      disabled={!isUpdateProfile}
                    >
                      {t("settings.save_profile_changes_cta")}
                    </button>
                  </div>
                </form>
              </section>
              {/* {--------------------USERMANAGEMENT SECTION --------------------------------} */}

              {!isGuestUser && (
                <section
                  id="user_management"
                  className="bg-white rounded-lg shadow-md px-[10px] lg:px-[30px] py-6 mb-8"
                >
                  <h2
                    className="text-2xl font-bold mb-4 text-gray-800"
                    id="user-management-title"
                  >
                    {t("settings.user_management")}
                  </h2>

                  <div
                    className="flex justify-between items-center mb-4"
                    id="user-management-header"
                  >
                    <span
                      className="text-sm text-gray-600"
                      id="user-count-display"
                    >
                      {guestUserCount} {t("settings.of")}{" "}
                      {billingDetails?.maxSubUserCount} {t("settings.user")}
                    </span>
                    <button
                      id="add-user-button"
                      className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                      onClick={() => {
                        if (isPremiumOrGuest) {
                          if (
                            guestUserCount < billingDetails?.maxSubUserCount
                          ) {
                            setOpenCreateUser(true);
                          } else {
                            toast.warning(t("settings.max_user_reached_msg"));
                          }
                        } else {
                          navigate(planPath.next);
                        }
                      }}
                    >
                      {t("settings.add_new_user_cta")}
                    </button>
                  </div>
                  <div
                    className="w-full max-w-full overflow-hidden"
                    id="user-management-table-container"
                  >
                    <Table
                      columns={[
                        {
                          Header: `${t("settings.email_label")}`,
                          accessor: "email",
                        },
                        {
                          Header: `${t("settings.status_label")}`,
                          accessor: "status",
                        },
                        {
                          Header: `${t("settings.actions_label")}`,
                          accessor: "actions",
                        },
                      ]}
                      data={mapGuestUserData}
                    />
                  </div>
                  <CreateNewUserModel
                    isOpen={openCreateUser}
                    setOpen={setOpenCreateUser}
                    parentId={userGuid}
                    CreateGuestUserConnect={GuestUserChangesConnect}
                    GetGuestUserConnect={GetGuestUserConnect}
                    setGuestUserData={setGuestUserData}
                    setGuestUserCount={setGuestUserCount}
                    parentEmail={userData?.email}
                    guestUserData={guestUserData}
                    currentLocale={currentLocale}
                    t={t}
                  />
                </section>
              )}

              {/* {--------------------BILLING SECTION --------------------------------} */}

              {!isGuestUser && (
                <section
                  className="bg-white rounded-lg shadow-lg py-8 px-[10px] lg:px-[30px] mb-8"
                  id="billing"
                >
                  <h2
                    className="text-[24px] lg:text-[30px] font-bold mb-6 text-gray-800"
                    id="billing-section-title"
                  >
                    {t("settings.billing")}
                  </h2>

                  {isBillingLoading ? (
                    <Loader isLoading={isBillingLoading} />
                  ) : (
                    <div
                      className="mb-8 bg-gradient-to-r from-blue-500 to-insightful-purple rounded-lg p-6 text-white"
                      id="billing-plan-container"
                    >
                      {PLAN_KEY ? (
                        <>
                          {isPremiumOrGuest && !CANCELLED_USER ? (
                            <CurrentPlan
                              planKey={PLAN_KEY}
                              description={
                                isScheduleCancel
                                  ? cancelDescription
                                  : updatedPlanDescription
                              }
                              nextBillingDate={
                                !isScheduleCancel && NEXT_BILLING_DATE
                              }
                              isScheduleCancel={isScheduleCancel}
                              onReactivate={handleReactivate}
                              t={t}
                            />
                          ) : (
                            <CancelledPlan
                              description={
                                isScheduleCancel
                                  ? cancelDescription
                                  : updatedPlanDescription
                              }
                              isScheduleCancel={isScheduleCancel}
                              onReactivate={handleReactivate}
                              onBuyNow={() => navigate(planPath.next)}
                              t={t}
                            />
                          )}
                        </>
                      ) : (
                        <DefaultPlan
                          planKey={defaultPlanKey}
                          description={defaultPlanDescription}
                          onBuyNow={() => navigate(planPath.next)}
                          t={t}
                        />
                      )}
                    </div>
                  )}
                </section>
              )}

              {/* {--------------------SECURITY SETTING SECTION --------------------------------} */}
              {isNormalUser && (
                <section
                  id="security"
                  className="bg-white rounded-lg shadow-lg py-8 px-[10px] lg:px-[30px] mb-8"
                >
                  <h2
                    className="text-[24px] lg:text-[30px] font-bold mb-6 text-gray-800"
                    id="security-section-title"
                  >
                    {t("settings.security_settings")}
                  </h2>

                  <div
                    className="mb-8 bg-white rounded-lg p-6 border border-gray-200 shadow-md"
                    id="password-change-container"
                  >
                    <h3
                      className="text-2xl font-semibold mb-4 text-gray-800"
                      id="password-change-title"
                    >
                      {t("settings.change_password")}
                    </h3>
                    <p
                      className="text-gray-600 mb-6"
                      id="password-change-description"
                    >
                      {t("settings.securityMessage")}
                    </p>
                    <form
                      className="space-y-4"
                      onSubmit={handleSubmitChangePassword}
                      id="password-change-form"
                    >
                      <div
                        className="flex flex-col w-full"
                        id="current-password-field-wrapper"
                      >
                        <label
                          htmlFor="current-password"
                          className="block text-sm font-medium text-gray-700 mb-1"
                          id="current-password-label"
                        >
                          {t("settings.current_password_label")}
                        </label>
                        <div
                          className="flex items-center"
                          id="current-password-input-container"
                        >
                          <input
                            id="settings-page-current-password-input"
                            type={
                              showPassword.currentPassword ? "text" : "password"
                            }
                            name="currentPassword"
                            className="w-full px-3 border border-insightful-gray border-1 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-insightful-purple focus:border-insightful-purple"
                            placeholder={t(
                              "settings.current_password_placeholder",
                            )}
                            onChange={handleChangePassword}
                            value={changePassword.currentPassword}
                          />
                          <button
                            id="settings-page-current-password-toggle-button"
                            type="button"
                            className="ml-[-30px] pr-3 flex items-center text-sm leading-5 text-gray-500"
                            onClick={() =>
                              togglePasswordVisibility("currentPassword")
                            }
                          >
                            <svg
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                          </button>
                        </div>
                        {changePasswordError.currentPasswordErr && (
                          <div
                            className="text-red-500 text-sm "
                            id="current-password-error"
                          >
                            {changePasswordError.currentPasswordErr}
                          </div>
                        )}
                      </div>
                      <div
                        className="flex flex-col w-full"
                        id="new-password-field-wrapper"
                      >
                        <label
                          htmlFor="new-password"
                          className="block text-sm font-medium text-gray-700 mb-1"
                          id="new-password-label"
                        >
                          {t("settings.new_password_label")}
                        </label>
                        <div
                          className="flex items-center"
                          id="settings-page-new-password-input-container"
                        >
                          <input
                            id="settings-page-new-password-input"
                            type={
                              showPassword.newPassword ? "text" : "password"
                            }
                            name="newPassword"
                            value={changePassword.newPassword}
                            className="w-full px-3 border border-insightful-gray border-1 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-insightful-purple focus:border-insightful-purple"
                            placeholder={t("settings.new_password_placeholder")}
                            onChange={handleChangePassword}
                          />
                          <button
                            id="settings-page-new-password-toggle-button"
                            type="button"
                            className="ml-[-30px] pr-3 flex items-center text-sm leading-5 text-gray-500 top-0"
                            onClick={() =>
                              togglePasswordVisibility("newPassword")
                            }
                          >
                            <svg
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                          </button>
                        </div>
                        {changePasswordError.newPasswordErr && (
                          <div
                            className="text-red-500 text-sm"
                            id="new-password-error"
                          >
                            {changePasswordError.newPasswordErr}
                          </div>
                        )}
                      </div>
                      <div
                        className="flex flex-col w-full"
                        id="confirm-password-field-wrapper"
                      >
                        <label
                          htmlFor="confirm-password"
                          className="block text-sm font-medium text-gray-700 mb-1"
                          id="confirm-password-label"
                        >
                          {t("settings.confirm_new_password_label")}
                        </label>
                        <div
                          className="flex items-center"
                          id="settings-page-confirm-password-input-container"
                        >
                          <input
                            id="settings-page-confirm-password-input"
                            type={
                              showPassword.confirmPassword ? "text" : "password"
                            }
                            name="confirmPassword"
                            className="w-full px-3 border border-insightful-gray border-1 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-insightful-purple focus:border-insightful-purple"
                            placeholder={t(
                              "settings.confirm_new_password_placeholder",
                            )}
                            value={changePassword.confirmPassword}
                            onChange={handleChangePassword}
                          />
                          <button
                            id="settings-page-confirm-password-toggle-button"
                            type="button"
                            className="ml-[-30px] pr-3 flex items-center text-sm leading-5 text-gray-500 top-0"
                            onClick={() =>
                              togglePasswordVisibility("confirmPassword")
                            }
                          >
                            <svg
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                          </button>
                        </div>
                        {changePasswordError.confirmPasswordErr && (
                          <div
                            className="text-red-500 text-sm"
                            id="confirm-password-error"
                          >
                            {changePasswordError.confirmPasswordErr}
                          </div>
                        )}
                      </div>
                      <div
                        className="flex items-center mt-4"
                        id="password-change-checkbox-container"
                      >
                        <input
                          id="settings-page-password-change-checkbox"
                          type="checkbox"
                          className="h-4 w-4 text-insightful-purple focus:ring-insightful-purple border-insightful-gray border-1 py-2 rounded"
                          name="changePasswordCheck"
                          value={changePasswordCheck}
                          onChange={(e) =>
                            setChangePasswordCheck(e.target.checked)
                          }
                        />
                        <label
                          htmlFor="terms"
                          className="ml-2 block text-sm text-gray-900"
                          id="password-change-checkbox-label"
                        >
                          {t("settings.password_change_message")}
                        </label>
                      </div>
                      <div
                        className="mt-6 flex justify-center lg:justify-end"
                        id="settings-page-password-change-submit-container"
                      >
                        <button
                          id="settings-page-password-change-submit-button"
                          type="submit"
                          className={`bg-insightful-purple text-white font-semibold py-2 px-6 rounded-md hover:bg-insightful-purple focus:outline-none focus:ring-2 focus:ring-insightful-purple focus:ring-offset-2 transition duration-300 ease-in-out flex items-center ${
                            !changePasswordCheck ? "cursor-not-allowed" : ""
                          }`}
                          disabled={!changePasswordCheck}
                        >
                          <img
                            src={Lock}
                            alt=""
                            className="w-5 h-5 mr-2 text-white border-white"
                            id="password-change-lock-icon"
                          />
                          {t("settings.update_password_cta")}
                        </button>
                      </div>
                    </form>
                  </div>
                </section>
              )}

              {/* {--------------------ACCOUNT CANCELATION SECTION --------------------------------} */}
              {!isGuestUser && isPremiumOrGuest && (
                <section
                  id="cancellation"
                  className={
                    !!isScheduleCancel && isScheduleCancel == true
                      ? "hidden"
                      : "bg-white rounded-lg shadow-lg py-6 px-[10px] lg:px-[30px]  mb-8 flex flex-col justify-center"
                  }
                >
                  <h2
                    className="text-2xl font-bold mb-4 text-gray-800 text-left"
                    id="cancellation-section-title"
                  >
                    {t("settings.account_cancellation")}
                  </h2>
                  <p
                    className="mb-4 text-gray-600"
                    id="cancellation-warning-text"
                  >
                    {t("settings.deletion_warning")}
                  </p>
                  <CancelPlanPopup
                    isOpen={isOpenCancellation}
                    setIsOpen={setIsOpenCancellation}
                    onConfirm={handleAccountCancellation}
                  />
                  <div
                    className="w-full flex items-center justify-center lg:justify-end"
                    id="cancellation-button-container"
                  >
                    <button
                      id="settings-page-cancel-account-button"
                      className="px-2 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                      // onClick={handleAccountCancellation}
                      onClick={() => {
                        setIsOpenCancellation(true);
                      }}
                    >
                      {t("settings.cancel_account_cta")}
                    </button>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Settings;

const CurrentPlan = ({
  planKey,
  description,
  nextBillingDate,
  isScheduleCancel,
  onReactivate,
  t,
}) => {
  // Replace `YYYY` dynamically & remove `$$`
  const updatedDescription = description
    .replace("YYYY", "")
    .replace(/\$\$/g, "");
  const fixedDescription = updatedDescription.replace(". .", ".");

  return (
    <div className="flex justify-between items-center">
      <div>
        <h3 className="text-xl font-semibold mb-2">
          {t("settings.current_plan")}
        </h3>
        <p className="text-2xl font-bold">{planKey}</p>
        <p dangerouslySetInnerHTML={{ __html: fixedDescription }} />
        {/* <p className="text-sm opacity-80">{description}</p> */}
        {nextBillingDate && (
          <p className="text-sm opacity-80">
            {t("settings.nextBillingDate")}: {nextBillingDate}
          </p>
        )}
      </div>
      {isScheduleCancel && (
        <Button text={t("settings.reactivate_cta")} onClick={onReactivate} />
      )}
    </div>
  );
};

const CancelledPlan = ({
  description,
  isScheduleCancel,
  onReactivate,
  onBuyNow,
  t,
}) => {
  // Replace `YYYY` dynamically & remove `$$`
  const updatedDescription = description
    .replace("YYYY", "")
    .replace(/\$\$/g, "");
  const fixedDescription = updatedDescription.replace(". .", ".");

  return (
    <div className="flex justify-between items-center flex-wrap gap-2 lg:gap-0">
      <div className="max-w-screen-md">
        <p dangerouslySetInnerHTML={{ __html: fixedDescription }} />
        {/* <p className="text-lg font-bold">{description}</p> */}
      </div>
      {isScheduleCancel ? (
        <Button
          id="settings-page-reactivate-btn"
          text={t("settings.reactivate_cta")}
          onClick={onReactivate}
        />
      ) : (
        <Button
          text="Buy Now"
          onClick={onBuyNow}
          id="settings-page-buy-now-btn"
        />
      )}
    </div>
  );
};

const DefaultPlan = ({ onBuyNow, t, description, planKey }) => (
  <div className="flex justify-between items-center flex-wrap gap-2 lg:gap-0">
    <div className="max-w-screen-md">
      <p className="text-2xl font-bold">{planKey}</p>
      <p className="text-lg">
        <p dangerouslySetInnerHTML={{ __html: description }} />
      </p>
    </div>
    <Button
      text={t("settings.buy_now_cta")}
      onClick={onBuyNow}
      id="settings-page-buy-now-btn"
    />
  </div>
);

const Button = ({ text, onClick }) => (
  <button
    className="px-4 py-2 bg-white text-insightful-purple rounded-md hover:bg-insightful-lightest-purple transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
    onClick={onClick}
  >
    {text}
  </button>
);
